// extracted by mini-css-extract-plugin
export default {"services":"PriceWithOptionsCell-services_IPkFn","priceBox":"PriceWithOptionsCell-priceBox_yWzjI","quotedProductOptions":"PriceWithOptionsCell-quotedProductOptions_aND7K"};